export function getContrastColor(inputColor: string): 'black' | 'white' {
  const parseColor = (color: string): { r: number; g: number; b: number } => {
    if (color.startsWith('rgba') || color.startsWith('rgb')) {
      const [r, g, b] = color
        .replace(/rgba?\(/, '')
        .replace(')', '')
        .split(',')
        .map((value) => parseFloat(value.trim()));
      return { r, g, b };
    } else if (color.startsWith('#')) {
      const sanitizedHex = color.replace('#', '');
      const bigint = parseInt(sanitizedHex, 16);
      return {
        r: (bigint >> 16) & 255,
        g: (bigint >> 8) & 255,
        b: bigint & 255,
      };
    } else {
      const ctx = document.createElement('canvas').getContext('2d');
      if (ctx) {
        ctx.fillStyle = color;
        const computedColor = ctx.fillStyle; // Convert to HEX
        return parseColor(computedColor);
      }
      throw new Error('Invalid color format');
    }
  };

  const calculateLuminance = ({ r, g, b }: { r: number; g: number; b: number }) => {
    const normalize = (value: number) => {
      const proportion = value / 255;
      return proportion <= 0.03928
        ? proportion / 12.92
        : Math.pow((proportion + 0.055) / 1.055, 2.4);
    };

    const R = normalize(r);
    const G = normalize(g);
    const B = normalize(b);

    return 0.2126 * R + 0.7152 * G + 0.0722 * B;
  };

  const isLightColor = (luminance: number) => luminance > 0.5;

  const rgb = parseColor(inputColor);
  const luminance = calculateLuminance(rgb);

  return isLightColor(luminance) ? 'black' : 'white';
}